/**
 * i18n Configuration
 * Centralized configuration for i18next
 */

export interface I18nConfig {
  fallbackLng: string;
  supportedLngs: string[];
  defaultNS: string;
  ns: string[];
  debug: boolean;
  interpolation: {
    escapeValue: boolean;
  };
  backend?: {
    loadPath: string;
  };
}

export const i18nConfig: I18nConfig = {
  fallbackLng: 'en',
  supportedLngs: ['en', 'uk', 'ar'],
  defaultNS: 'common',
  ns: ['common', 'validation', 'errors'],
  debug: process.env.NODE_ENV === 'development',
  interpolation: {
    escapeValue: false, // React escapes by default
  },
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
  },
};

export default i18nConfig;

